const mapIconToCarType = ( carTypes ) =>
  carTypes.map( carType => {
    let iconName = '', isCar = false;
    switch ( carType.description ) {
      case 'Car/Wagon': {
        iconName = 'car-icon.png';
        isCar = true;
        break;
      }
      case '4WD/SUV': {
        iconName = '4wd-suv-icon.png';
        isCar = true;
        break;
      }
      case 'Special': {
        iconName = 'special-icon.png';
        isCar = true;
        break;
      }
      case 'Motorcycle': {
        iconName = 'moto-icon.png';
        isCar = false;
        break;
      }
      case 'Boat': {
        iconName = 'boat-icon.png';
        isCar = false;
        break;
      }
      case 'Jetski': {
        iconName = 'jetski-icon.png';
        isCar = false;
        break;
      }
      case 'Trailer': {
        iconName = 'trailer-icon.png';
        isCar = false;
        break;
      }
      case 'Other': {
        iconName = 'other-icon.png';
        isCar = false;
        break;
      }
      case 'Caravan': {
        iconName = 'other-icon.png';
        isCar = false;
        break;
      }
    }
    return { ...carType, icon: `/wp-content/themes/nationalcarmovers/assets/images/icons/${iconName}`, isCar }
  } );

const mapFirstStepFormToRequest = ( {
  vehicles,
  from,
  to,
  manufacturer,
  model,
  year,
  drivable,
  modifications,
  detailsOfModification,
} ) => ({
  fromSuburbID: from,
  toSuburbID: to,
  vehicleMake: manufacturer,
  vehicleModel: model,
  year,
  isDrivable: drivable === 'true' ? 'Y' : 'N',
  isModification: modifications === 'true' ? 'Y' : 'N',
  comments: detailsOfModification
});

const mapNonCarFormToRequest = ( {
  vehicles,
  from,
  to,
  nonCarMake,
  nonCarModel,
  description,
  year,
  length,
  height,
  width,
  weight,
  firstName,
  email,
  phone
} ) => ({
  carTypeID: vehicles,
  fromSuburbID: from,
  toSuburbID: to,
  vehicleMakeName: nonCarMake,
  vehicleModelName: nonCarModel,
  vehicleDescription: description,
  year,
  length,
  height,
  weight,
  width,
  name: firstName,
  email,
  phone
});

const mapSecondStepFormToRequest = ( { quoteId, GUID, firstName, email, phone } ) => ({
  id: quoteId,
  GUID,
  name: firstName,
  email,
  phone
});

const mapErrorsToForm = ( error ) => {
  switch ( error.property_path ) {
    case 'fromSuburbID':
      return 'from';
    case 'toSuburbID':
      return 'to';
    case 'vehicleMake':
      return 'manufacturer';
    case 'vehicleModel':
      return 'model';
    case 'isDrivable':
      return 'drivable';
    case 'isModification':
      return 'modifications';
    case 'name':
      return 'firstName';
    case 'bookingDate':
      return 'date';
    case 'bookingName':
      return 'firstName';
    case 'pickupEmail':
      return 'originEmail';
    case 'pickupPhone':
      return 'originPhone';
    case 'pickupAddress':
      return 'originAddress';
    case 'deliveryContact':
      return 'deliveryName';
    case 'vehicleMakeName':
      return 'nonCarMake';
    case 'vehicleModelName':
      return 'nonCarModel';
    case 'vehicleDescription':
      return 'description';
    case 'companyName':
      return 'invoiceName';
    case 'companyEmail':
      return 'invoiceEmail';
    case 'paymentType':
      return 'paymentWay';
    default:
      return error.property_path;
  }
};

const mapBook1ToRequest = ( { regoVin, colour, date } ) => ({
  regoVin,
  colour,
  bookingDate: date
});

const mapBook2ToRequest = ( { firstName, email, phone } ) => ({
  bookingName: firstName,
  email,
  phone
});

const mapOriginDetailsToRequest = ( { originName, originEmail, originPhone, originAddress } ) => ({
  pickupEmail: originEmail,
  pickupPhone: originPhone,
  pickupAddress: originAddress
});

const mapDeliveryDetailsToRequest = ( { deliveryName, deliveryEmail, deliveryPhone, deliveryAddress } ) => ({
  deliveryContact: deliveryName,
  deliveryEmail,
  deliveryPhone,
  deliveryAddress
});

const mapSecurePaymentToRequest = ( { invoiceName, invoiceEmail, paymentWay } ) => ({
  companyName: invoiceName,
  companyEmail: invoiceEmail,
  paymentType: paymentWay
});
